export const COLOR_TRANSPARENT = 'transparent';
export const COLOR_BLACK = '#000000';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_GRAY_00 = '#F1EDEB';
export const COLOR_GRAY_100 = '#E5DED9';
export const COLOR_GRAY_200 = '#CAC7C7';
export const COLOR_GRAY_400 = '#949494';
export const COLOR_GRAY_600 = '#666666';
export const COLOR_GRAY_800 = '#414141';
export const COLOR_BRAND_WHITE = COLOR_WHITE;
export const COLOR_BRAND_ORANGE_300 = '#EE7F00';
export const COLOR_BRAND_ORANGE_500 = '#EA650D';
export const COLOR_BRAND_ORANGE_700 = '#E64415';
export const COLOR_PRIMARY_ORANGE_00 = '#FFF7EE';
export const COLOR_PRIMARY_ORANGE_100 = '#F6BF80';
export const COLOR_PRIMARY_ORANGE_300 = '#EE7F00';
export const COLOR_PRIMARY_ORANGE_500 = '#EA650D';
export const COLOR_PRIMARY_ORANGE_700 = '#E64415';
export const COLOR_SECONDARY_BLUE_00 = '#CCDBF2';
export const COLOR_SECONDARY_BLUE_100 = '#99B7E5';
export const COLOR_SECONDARY_BLUE_300 = '#6693D8';
export const COLOR_SECONDARY_BLUE_500 = '#336FCB';
export const COLOR_SECONDARY_BLUE_700 = '#004BBE';
export const COLOR_SECONDARY_GREEN_00 = '#D2E9E4';
export const COLOR_SECONDARY_GREEN_100 = '#A7D3CA';
export const COLOR_SECONDARY_GREEN_300 = '#7EBEAF';
export const COLOR_SECONDARY_GREEN_500 = '#5AA896';
export const COLOR_SECONDARY_GREEN_700 = '#347663';
export const COLOR_SECONDARY_PURPLE_00 = '#E1DDEF';
export const COLOR_SECONDARY_PURPLE_100 = '#BDB6DD';
export const COLOR_SECONDARY_PURPLE_300 = '#9B91CC';
export const COLOR_SECONDARY_PURPLE_500 = '#796ABB';
export const COLOR_SECONDARY_PURPLE_700 = '#35219B';
